export function passwordChangeHandleChangeFunc(e, setErrorFromServer, setChangePasswordVal, changePasswordVal) {
    setErrorFromServer("");
    const { name, value } = e.target;
    setChangePasswordVal({
      ...changePasswordVal,
      [name]: value,
    });
}